import React from 'react';
import { Route, Routes } from 'react-router-dom';
import AuthProvider from './contexts/AuthContext';
import { WarehouseProvider } from './contexts/WarehouseContext';
import AppRoutes from './routes/AppRoutes';
import './assets/styles/style.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './i18n';
import { LanguageProvider } from './contexts/LanguageContext';
import { LoadingProvider } from './contexts/LoadingContext';
import { PermissionsProvider } from './contexts/PermissionsContext';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';

const App = () => {
  return (
    <>
      <ErrorBoundary>
        <LoadingProvider>
          <LanguageProvider>
            <AuthProvider>
              <PermissionsProvider>
                <WarehouseProvider>
                  <Routes>
                    {/* Main App Routes  */}
                    <Route path="/*" element={<AppRoutes />} />
                  </Routes>
                </WarehouseProvider>
              </PermissionsProvider>
            </AuthProvider>
          </LanguageProvider>
        </LoadingProvider>
      </ErrorBoundary>

      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
};

export default App;
